let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hYaAe")).then(() => parcelRequire('dIbk1'));